import { SET_INFRASTRUCTURE } from '../constants/constants'

// eslint-disable-next-line default-param-last
const infrastructure = (state = {}, action) => {
    if (action.type === SET_INFRASTRUCTURE) {
        return action.payload
    }

    return state
}

export default infrastructure
